import React from 'react'
import { useSelector } from 'react-redux'

const Loader = () => {

    const { loader } = useSelector((state) => state.CommonReducer)

    return (
        <>
            {
                loader &&
                <div className='loader_section'>
                    <div className='overlay_loader'></div>
                    <div class="loader">
                        <div class="ring"></div>
                        <div class="ring"></div>
                        <div class="ring"></div>
                    </div>
                </div>
            }
        </>
    )
}

export default Loader